module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "about"
  }, [_c('div', {
    staticClass: "about-header",
    style: ({
      background: _vm.skinColor
    })
  }, [_c('i', {
    staticClass: "fa fa-chevron-left",
    attrs: {
      "aria-hidden": "true"
    },
    on: {
      "click": _vm.hiddenAbout
    }
  }), _vm._v("关于\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "about-content"
  }, [_c('h2', {
    staticClass: "about-content-title"
  }, [_vm._v("Vue全家桶开发开源的CNode社区")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('ul', {
    staticClass: "skills",
    style: ({
      borderLeftColor: _vm.skinColor.replace(/\sl[\S\s]+/, '').replace(/(1)(\))/, '0.4$2')
    })
  }, _vm._l((_vm.skills), function(skill, index) {
    return _c('li', {
      key: index,
      staticClass: "skill",
      class: {
        active: index === _vm.skillIndex
      },
      style: ({
        background: index === _vm.skillIndex ? _vm.skinColor.replace(/\sl[\S\s]+/, '').replace(/(1)(\))/, '0.4$2') : '',
        borderRightColor: _vm.skinColor.replace(/\sl[\S\s]+/, '')
      }),
      on: {
        "click": function($event) {
          _vm.skillClick(index)
        }
      }
    }, [_c('span', {
      staticClass: "name"
    }, [_vm._v(_vm._s(skill.name))]), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (skill.des),
        expression: "skill.des"
      }],
      staticClass: "des"
    }, [_vm._v("[ " + _vm._s(skill.des) + " ]")])])
  })), _vm._v(" "), _vm._m(1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "skill-title"
  }, [_c('b', [_vm._v("技术栈")]), _vm._v("：")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "project"
  }, [_c('p', {
    staticClass: "link"
  }, [_c('b', [_vm._v("项目地址: ")]), _c('a', {
    staticClass: "title",
    attrs: {
      "href": "https://github.com/LDQ-first/vue-CNode"
    }
  }, [_vm._v("GitHub")])]), _vm._v(" "), _c('p', {
    staticClass: "link"
  }, [_c('b', [_vm._v("反馈: ")]), _c('a', {
    staticClass: "title",
    attrs: {
      "href": "https://github.com/LDQ-first/vue-CNode/issues"
    }
  }, [_vm._v("Issues")])]), _vm._v(" "), _c('p', {
    staticClass: "state"
  }, [_c('b', [_vm._v("声明: ")]), _vm._v("本项目只供学习使用，请不要用作任何商业用途。")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-26fb5d9c"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/components/About/About.vue
// module id = 329
// module chunks = 4